(function () {
    'use strict';

    function requestOptionsDataService($http) {
        var url = '/requestoptions';

        function getRequestOptions() {
            return $http.get(url).then(function (response) {
                return response.data;
            });
        };

        return {
            getRequestOptions: getRequestOptions
        }
    }

    requestOptionsDataService.$inject = ['$http'];

    angular.module('ecap.common').service('requestOptionsDataService', requestOptionsDataService);
})();
